import React, { useEffect, useRef, useState } from "react";
import { Button, Col, Row, Table } from "react-bootstrap";

import { useNavigate, useParams } from "react-router-dom";
import DeleteButton from "src/components/DeleteButton";
import DetailButton from "src/components/DetailButton";
import EditButton from "src/components/EditButton";
import GoBackButton from "src/components/GoBackButton";
import TagModal from "src/components/modals/TagModal";
import Title from "src/components/Title";
import API from "src/services/api";
import BootstrapTable from "../components/BootstrapTable";
import TableFormatter from "../utils/tableFormatter";

const TaggroupDetailSite = () => {
  const table = useRef();
  const { taggroup_id } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState();
  const [isLoading, setIsLoading] = useState(true);

  const loadData = async () => {
    const res = await API.getTaggroup(taggroup_id);
    if (res.status === true) {
      setData(res.data);
    }
    setIsLoading(false);
  };

  // Load notes when component is rendered the first time
  useEffect(() => {
    if (taggroup_id) {
      loadData();
    }
  }, [taggroup_id]);

  const deleteTaggroup = async () => {
    if (window.confirm("Taggruppe löschen?")) {
      await API.deleteTaggroup(taggroup_id);
      loadData();
    }
  };

  const deleteTag = async (tag_id) => {
    if (window.confirm("Tag löschen?")) {
      await API.deleteTag(tag_id);
      loadData();
    }
  };

  if (isLoading) {
    return <Title>Wird geladen...</Title>;
  }

  return (
    <React.Fragment>
      <Row>
        <Col>
          <Title>Taggruppe</Title>
        </Col>
      </Row>
      <Row>
        <Col>
          <GoBackButton />
        </Col>
        <Col className="text-end">
          <Button
            variant="default"
            onClick={() => navigate(`/taggroup/edit/${taggroup_id}`)}
          >
            Bearbeiten
          </Button>{" "}
          <Button variant="danger" onClick={() => deleteTaggroup()}>
            Löschen
          </Button>
        </Col>
      </Row>
      <Row>
        <Col>
          <Table>
            <tbody>
              <tr>
                <th>ID</th>
                <td>{data.id}</td>
              </tr>
              <tr>
                <th>swipetype_id</th>
                <td>{data.swipetype_id}</td>
              </tr>
              <tr>
                <th>Name</th>
                <td>{data.name}</td>
              </tr>
              <tr>
                <th>GUI-Reihenfolge</th>
                <td>{data.gui_order}</td>
              </tr>
              <tr>
                <th>is_visible_for_view</th>
                <td>
                  {TableFormatter.formatBoolean(data.is_visible_for_view)}
                </td>
              </tr>
              <tr>
                <th>is_visible_for_filtering</th>
                <td>
                  {TableFormatter.formatBoolean(data.is_visible_for_filtering)}
                </td>
              </tr>
              <tr>
                <th>is_visible_for_edit</th>
                <td>
                  {TableFormatter.formatBoolean(data.is_visible_for_edit)}
                </td>
              </tr>
              <tr>
                <th>is_multiple_on_enter</th>
                <td>
                  {TableFormatter.formatBoolean(data.is_multiple_on_enter)}
                </td>
              </tr>
              <tr>
                <th>Erstellt am</th>
                <td>{TableFormatter.formatDateTime(data.created_at)}</td>
              </tr>
              <tr>
                <th>Geändert am</th>
                <td>{TableFormatter.formatDateTime(data.updated_at)}</td>
              </tr>
              <tr>
                <th>Gelöscht am</th>
                <td>{TableFormatter.formatDateTime(data.deleted_at)}</td>
              </tr>
            </tbody>
          </Table>
        </Col>
        <Col>
          <h2>Zugewiesene Tags</h2>
          <TagModal
            taskgroupId={taggroup_id}
            onSubmitModal={() => table.current.refresh()}
          />
          <BootstrapTable
            url={`/api/backend/taggroup/${taggroup_id}/tags`}
            sort="name"
            order="asc"
            pageSize={25}
            ref={table}
            pageSizes={[25, 50, 100, 250]}
            columns={[
              {
                field: "name",
                name: "Name",
                sortable: true,
              },
              {
                field: "icon",
                name: "icon",
                sortable: true,
              },
              {
                field: "gui_order",
                name: "GUI-Reihenfolge",
                sortable: true,
              },
              {
                field: "id",
                textAlign: "right",
                width: 120,
                formatter: (value) => {
                  return (
                    <React.Fragment>
                      <DetailButton url={`/tag/${value}`} />{" "}
                      <EditButton url={`/tag/edit/${value}`} />{" "}
                      <DeleteButton onClick={() => deleteTag(value)} />
                    </React.Fragment>
                  );
                },
              },
            ]}
          />
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default TaggroupDetailSite;
